<template>
  <b-nav-item-dropdown menu-class="media-list dropdown-menu-right tasks-notification-menu" toggle-class="f-s-14" no-caret>
    <template slot="button-content">
      <i class="fas fa-bell"></i>
      <span class="label" v-if="tasksNotificationCount > 0">{{ tasksNotificationCount }}</span>
      <span class="label" v-else>0</span>
    </template>
    <b-dropdown-header>{{ $t('Notifications') }} ({{ tasksNotificationCount }})</b-dropdown-header>
    <b-dropdown-item v-if="tasksNotificationList.length === 0" class="text-center">
      <span class="text-muted">{{ $t('No notifications') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-for="task in tasksNotificationList"
      :key="task.id"
      class="media"
      @click="openTaskModal(task)"
    >
      <div class="d-flex">
        <div class="media-body">
          <p class="media-heading text-wrap">
            <i :class="notificationIcon(task)" class="mr-1 text-muted" />
            {{ task.body}}
          </p>
        </div>
      </div>
    </b-dropdown-item>

    <task-notification-modal
      v-if="showTaskModal"
      :task-id="selectedTaskId"
      @close="onTaskModalClose"
    />

    <task-comment-notification-modal
      v-if="showCommentModal"
      :task-id="selectedTaskId"
      @close="onCommentModalClose"
    />
  </b-nav-item-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as NOTIFICATION_TYPES } from '@/pages/notify/notification/store'
import { TASKS_NOTIFICATION_POLLING_INTERVAL_MILLISECONDS, TASK_NOTIFICATION_SLUGS } from '@/const'
import { ROUTES as ACTIVITY_ROUTES } from '@/pages/activity/router'
import TaskNotificationModal from './TaskNotificationModal.vue'
import TaskCommentNotificationModal from './TaskCommentNotificationModal.vue'

export default {
  name: 'TasksNotificationDropDown',
  components: {
    TaskNotificationModal,
    'task-comment-notification-modal': TaskCommentNotificationModal
  },
  data () {
    return {
      interval: undefined,
      showTaskModal: false,
      showCommentModal: false,
      selectedTaskId: null
    }
  },
  created () {
    this.fetch()
    this.interval = setInterval(this.fetch, TASKS_NOTIFICATION_POLLING_INTERVAL_MILLISECONDS)
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  computed: {
    ...mapGetters({
      tasksNotificationCount: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.GETTERS.tasksNotificationCount,
      tasksNotificationList: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.GETTERS.tasksNotificationList
    })
  },
  methods: {
    ...mapActions({
      getTasksNotification: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.ACTIONS.getTasksNotification,
      setRead: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.ACTIONS.setRead
    }),
    fetch () {
      this.getTasksNotification()
    },
    isCommentNotification (notification) {
      return notification.slug === TASK_NOTIFICATION_SLUGS.taskComment
    },
    isAssigneeNotification (notification) {
      return notification.slug === TASK_NOTIFICATION_SLUGS.taskAssignee
    },
    notificationIcon (notification) {
      if (this.isCommentNotification(notification)) return 'fas fa-comments'
      if (this.isAssigneeNotification(notification)) return 'fas fa-user-plus'
      return 'fas fa-bell'
    },
    openTaskModal (notification) {
      this.selectedTaskId = notification.call_to_action_label
      if (this.isAssigneeNotification(notification)) {
        // "aggiunto come incaricato": porta ai propri ticket e apre il dettaglio
        this.$router.push({
          name: ACTIVITY_ROUTES.ACTIVITY_MY,
          query: { openTaskId: String(notification.call_to_action_label) }
        }).catch(() => {})
        this.setRead({ id: notification.id }).then(() => this.fetch())
        return
      }
      if (this.isCommentNotification(notification)) {
        this.showCommentModal = true
      } else {
        this.showTaskModal = true
      }
      this.setRead({ id: notification.id }).then(() => this.fetch())
    },
    onTaskModalClose () {
      this.showTaskModal = false
      this.selectedTaskId = null
    },
    onCommentModalClose () {
      this.showCommentModal = false
      this.selectedTaskId = null
    }
  }
}
</script>
